













































































































































































































import {
  defineNuxtComponent,
  ref,
  useRoute,
  computed,
  useRouter,
  watch,
  useFetchState,
  useFetch
} from '~/utils/nuxt3-migration'
import ClassifiedSearchService from '~/services/search/ClassifiedSearchService'
import { quickSearchCategories } from '~/constants/classified/quick-search'
import { categoriesIconsMappings } from '~/constants/category/icon'
import { useDep } from '~/compositions/dependency-container'
import { useRequestError } from '~/compositions/request-error'
import { useI18n } from '~/compositions/i18n'
import { resolveCategory } from '~/utils/category'
import { CategoryId, QuickSearchCategory } from '~/models/category/types'
import CSpinner from '~/components/shared/configurable/CSpinner.vue'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import CCategoryIcon from '~/components/shared/configurable/category/CCategoryIcon.vue'
import ClassifiedQuickSearchCategoryListSecondLevel from '~/components/car/classifieds/quick-search/ClassifiedQuickSearchCategoryListSecondLevel.vue'
import ClassifiedQuickSearchCategoryListFirstLevel from '~/components/car/classifieds/quick-search/ClassifiedQuickSearchCategoryListFirstLevel.vue'
import ClassifiedQuickSearchMakeModelHandler from '~/components/car/classifieds/quick-search/ClassifiedQuickSearchMakeModelHandler.vue'
import ClassifiedQuickSearchSelectRangeHandler from '~/components/car/classifieds/quick-search/ClassifiedQuickSearchSelectRangeHandler.vue'
import ClassifiedQuickSearchSelectHandler from '~/components/car/classifieds/quick-search/ClassifiedQuickSearchSelectHandler.vue'
import ClassifiedQuickSearchCategorySelectHandler from '~/components/car/classifieds/quick-search/ClassifiedQuickSearchCategorySelectHandler.vue'
import ClassifiedQuickSearchFrontEndOfferTypeCarsHandler from '~/components/car/classifieds/quick-search/ClassifiedQuickSearchFrontEndOfferTypeCarsHandler.vue'
import ClassifiedQuickSearchSmartFreeTextHandler from '~/components/car/classifieds/quick-search/ClassifiedQuickSearchSmartFreeTextHandler.vue'
import ClassifiedQuickSearchCategoryGridHandler from '~/components/car/classifieds/quick-search/ClassifiedQuickSearchCategoryGridHandler.vue'
import ClassifiedQuickSearchLocationHandler from '~/components/car/classifieds/quick-search/ClassifiedQuickSearchLocationHandler.vue'
import ClassifiedQuickSearchRecentSearchModal from '~/components/car/classifieds/quick-search/ClassifiedQuickSearchRecentSearchModal.vue'
import ClassifiedQuickSearchRentalsPopularSearches from '~/components/car/classifieds/quick-search/ClassifiedQuickSearchRentalsPopularSearches.vue'
import ClassifiedQuickSearchCategoryGridIconsHandler from '~/components/car/classifieds/quick-search/ClassifiedQuickSearchCategoryGridIconsHandler.vue'
import ClassifiedQuickSearchPickupLocationHandler from '~/components/car/classifieds/quick-search/ClassifiedQuickSearchPickupLocationHandler.vue'
import ClassifiedQuickSearchRentalPeriodHandler from '~/components/car/classifieds/quick-search/ClassifiedQuickSearchRentalPeriodHandler.vue'
import ClassifiedQuickSearchPostcodeHandler from '~/components/car/classifieds/quick-search/ClassifiedQuickSearchPostcodeHandler.vue'
import ClassifiedQuickSearchLocationAutocompleteHandler from '~/components/car/classifieds/quick-search/ClassifiedQuickSearchLocationAutocompleteHandler.vue'
import { ciFilters } from '~/icons/source/regular/filters'
import { ciHistory } from '~/icons/source/regular/history'
import { ciTrash } from '~/icons/source/regular/trash'
import { ciChevronLeft } from '~/icons/source/regular/chevron-left'
import { ciMap } from '~/icons/source/regular/map'
import { ciExternalLink } from '~/icons/source/regular/external-link'
import { AccessToggleName } from '~/models/user/access-toggles'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import { formatNumber } from '~/utils/number'
import { defineComponentTranslations } from '~/utils/i18n'
import { TranslateResult } from 'vue-i18n'
import { BackendMetaItem } from '~/models/head/types'
import CPosting from '~/components/shared/configurable/ad/CPosting.vue'
import { useUserAgent } from '~/compositions/user-agent'
import { objectsEqual } from '~/utils/object'

interface Facet {
  name: string
  type?: string
  values?: any[]
}

export default defineNuxtComponent({
  middleware({ redirect, route }) {
    const rootCategories = [
      'vehicles',
      'boats',
      'parts',
      'rentals',
      'xyma',
      'plot'
    ]

    if (route.params.root === 'service') {
      return redirect({
        name: '__vehicle_service_start',
        query: route.query
      })
    }

    if (
      (!route.params.root && !route.params.category) ||
      !rootCategories.includes(route.params.root)
    ) {
      return redirect({
        name: '__classifieds_quick_search',
        params: { root: 'vehicles', category: 'cars' },
        query: route.query
      })
    }

    if (route.params.root === 'vehicles') {
      if (route.params.category === 'boats') {
        return redirect({
          name: '__classifieds_quick_search',
          params: { root: 'boats' },
          query: route.query
        })
      }

      const commercialsCategories = [
        'vans',
        'trucks',
        'tractors',
        'builders',
        'semitrucks',
        'semitrailers',
        'buses',
        'forklifts',
        'trailers',
        'taxis'
      ]

      if (commercialsCategories.includes(route.params.category)) {
        return redirect({
          name: '__classifieds_quick_search',
          params: {
            root: 'vehicles',
            category: 'commercials',
            subCategory: route.params.category
          },
          query: route.query
        })
      }

      const vehiclesCategories = [
        'cars',
        'bikes',
        'commercials',
        'campers',
        'bicycles',
        'hobby'
      ]

      if (!vehiclesCategories.includes(route.params.category)) {
        return redirect({
          name: '__classifieds_quick_search',
          params: { root: 'vehicles', category: 'cars' },
          query: route.query
        })
      }
    }

    if (route.params.category === undefined) {
      const categoriesDefaults = {
        vehicles: 'cars',
        parts: 'for-cars',
        xyma: 'technology-security',
        plot: 'sale',
        rentals: 'cars'
      }

      const redirectToCategory = categoriesDefaults[route.params.root]

      if (redirectToCategory) {
        return redirect({
          name: '__classifieds_quick_search',
          params: {
            root: route.params.root,
            category: redirectToCategory
          },
          query: route.query
        })
      }
    }
  },
  components: {
    CCard,
    ClassifiedQuickSearchCategoryListFirstLevel,
    ClassifiedQuickSearchCategoryListSecondLevel,
    CCategoryIcon,
    CSpinner,
    ClassifiedQuickSearchRecentSearchModal,
    ClassifiedQuickSearchRentalsPopularSearches,
    CPosting
  },
  setup() {
    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const userHasAccessTo = userGetters('userHasAccessTo')
    const classifiedSearchService = useDep(ClassifiedSearchService)
    const handleRequestError = useRequestError()
    const route = useRoute()
    const router = useRouter()
    const { t } = useI18n()
    const { isPc } = useUserAgent()

    const recentSearchesModalIsOpen = ref(false)
    const loading = ref(false)
    const facets = useFetchState('facets', ref<Record<string, any>>({}))
    const categoryFacets = useFetchState('categoryFacets', ref<Facet[]>([]))
    const categoryChildren = useFetchState(
      'categoryChildren',
      ref<QuickSearchCategory[]>([])
    )
    const count = useFetchState('count', ref(0))
    const resultsUrl = useFetchState('resultsUrl', ref(''))
    const mapResultsUrl = useFetchState('mapResultsUrl', ref(''))
    const detailedSearchUrl = useFetchState('detailedSearchUrl', ref(''))
    const metadata = useFetchState('metadata', ref<BackendMetaItem[]>([]))

    const categories = computed(() => {
      if (!userHasAccessTo(AccessToggleName.WANTED_PARTS_ACCESS)) {
        return Object.values(quickSearchCategories).filter(
          category => category.id !== CategoryId.WANTED_PARTS
        )
      }
      return quickSearchCategories
    })

    const selectedCategories = computed(() => {
      const {
        firstLevelCategory,
        secondLevelCategory,
        thirdLevelCategory
      } = getCategoriesFromRoute()
      const ids = []
      if (firstLevelCategory) {
        ids.push(firstLevelCategory.id)
      }
      if (secondLevelCategory) {
        ids.push(secondLevelCategory.id)
      }
      if (thirdLevelCategory) {
        ids.push(thirdLevelCategory.id)
      }
      return ids
    })

    const rentalsQuickSearchHeading = computed(() => {
      const headings: Record<string, TranslateResult> = {
        cars: t('cars_rentals'),
        bikes: t('bikes_rentals'),
        boats: t('boats_rentals'),
        commercials: t('commercials_rentals'),
        campers: t('campers_rentals'),
        bicycles: t('bicycles_rentals'),
        misc: t('misc_rentals')
      }

      return (
        headings[route.value.params.category] || t(route.value.params.category)
      )
    })

    const quickSearchHeading = computed(() => {
      if (route.value.params.root === 'parts') {
        if (route.value.params.category === 'for-tools') {
          return t('for-tools')
        }

        if (route.value.params.category === 'for-trucks') {
          return isPc.value
            ? `${t('parts')} ${t('for-trucks')}`
            : `${t('parts')} ${t('for-commercial')}`
        }

        return `${t(route.value.params.root)} ${t(route.value.params.category)}`
      } else if (route.value.params.root === 'boats') {
        return t('boats_search')
      } else if (route.value.params.root === 'rentals') {
        return rentalsQuickSearchHeading.value
      } else if (route.value.params.root === 'vehicles') {
        if (route.value.params.subCategory) {
          return t(
            `${route.value.params.category}_${route.value.params.subCategory}_search`
          )
        }

        return t(`${route.value.params.category}_search`)
      } else if (route.value.params.subCategory) {
        return t(route.value.params.subCategory)
      }
      return t(route.value.params.category)
    })

    const hasSelectedFacets = computed(() => {
      return Object.keys(route.value.query).length > 0
    })

    const showLoadingScreen = computed(() => {
      return (
        categoryFacets.value.length === 0 && categoryChildren.value.length === 0
      )
    })

    const isPlotCategory = computed(() =>
      selectedCategories.value.includes(CategoryId.PLOT)
    )

    const isRentalsCategory = computed(() =>
      selectedCategories.value.includes(CategoryId.RENTALS)
    )

    const isBoatsCategory = computed(() =>
      selectedCategories.value.includes(CategoryId.BOATS)
    )

    const isCampersCategory = computed(() =>
      selectedCategories.value.includes(CategoryId.CAMPERS)
    )

    const isCommercialsCategory = computed(() =>
      selectedCategories.value.includes(CategoryId.COMMERCIAL)
    )

    const isHobbyCategory = computed(() =>
      selectedCategories.value.includes(CategoryId.HOBBY)
    )

    const isSmallClassifiedsCategory = computed(() =>
      selectedCategories.value.includes(CategoryId.XYMA)
    )

    const showMiddleColumn = computed(() => !isBoatsCategory.value)

    const showMoreFiltersButton = computed(() => {
      return (
        !isRentalsCategory.value &&
        !isCampersCategory.value &&
        !isHobbyCategory.value &&
        !(isCommercialsCategory.value && !route.value.params.subCategory) &&
        !isSmallClassifiedsCategory.value
      )
    })

    const backButtonLocation = computed(() => {
      if (isCommercialsCategory.value && route.value.params.subCategory) {
        return '/quick-search/vehicles/commercials'
      }

      return '/#quick-search'
    })

    const plotHeadingTranslationPath = computed(() => {
      if (selectedCategories.value.includes(CategoryId.PLOT_SALE)) {
        return 'sale_real_estate_through'
      } else if (selectedCategories.value.includes(CategoryId.PLOT_RENT)) {
        return 'rent_real_estate_through'
      } else if (selectedCategories.value.includes(CategoryId.PLOT_BOOKING)) {
        return 'booking_real_estate_through'
      }

      return 'wanted_real_estate_through'
    })

    const showDesktopBackButton = computed(() => {
      return isCommercialsCategory.value && route.value.params.subCategory
    })

    const showCtaButton = computed(() => {
      const isCommercialWithoutSubcategory =
        isCommercialsCategory.value && !route.value.params.subCategory

      return (
        !isCommercialWithoutSubcategory &&
        !isHobbyCategory.value &&
        !isCampersCategory.value
      )
    })

    useFetch(fetchData)

    watch(route, (newRoute, oldRoute) => {
      if (!objectsEqual(newRoute.query, oldRoute.query)) {
        fetchData()
      }
    })

    async function fetchData() {
      loading.value = true
      try {
        const categoryParam = selectedCategories.value as any[]
        if (route.value.query.category) {
          Array.isArray(route.value.query.category)
            ? categoryParam.push(...route.value.query.category)
            : categoryParam.push(route.value.query.category)
        }
        const params = {
          ...route.value.query,
          category: categoryParam,
          context: ['quick-search']
        }

        const data = await classifiedSearchService.getFacets(params)

        resultsUrl.value = data.targetSeoUrl
        mapResultsUrl.value = data.mapSearchUrl
        detailedSearchUrl.value = data.changeSearchUrl
        metadata.value = data.metadata
        animateCounter(count.value, data.stats.total)
        facets.value = transformFacetsToObject(data.facets)

        // Get the categories
        const {
          firstLevelCategory,
          secondLevelCategory,
          thirdLevelCategory
        } = getCategoriesFromRoute()

        const categoryFacetsConfig = getCategoryFacetsConfig(
          firstLevelCategory,
          secondLevelCategory,
          thirdLevelCategory
        )

        if (categoryFacetsConfig) {
          categoryFacets.value = categoryFacetsConfig.map(
            (facetConfig: any) => {
              const facetData = facets.value[facetConfig.name]
              return facetData ? { ...facetData, ...facetConfig } : facetConfig
            }
          )
        } else {
          categoryFacets.value = []
        }

        if (thirdLevelCategory) {
          categoryChildren.value = thirdLevelCategory.children || []
        } else if (secondLevelCategory) {
          categoryChildren.value = secondLevelCategory.children || []
        } else {
          categoryChildren.value = []
        }
      } catch (error) {
        handleRequestError(error)
      } finally {
        loading.value = false
      }
    }

    function animateCounter(start: number, end: number) {
      // Skip animation on server-side
      if (typeof window === 'undefined' || typeof performance === 'undefined') {
        count.value = end
        return
      }

      const duration = 1000
      const startTime = performance.now()

      const animate = (currentTime: number) => {
        const elapsed = currentTime - startTime
        const progress = Math.min(elapsed / duration, 1)
        count.value = Math.floor(start + (end - start) * progress)

        if (progress < 1) {
          requestAnimationFrame(animate)
        } else {
          count.value = end
        }
      }

      requestAnimationFrame(animate)
    }

    function transformFacetsToObject(fetchedFacets: any[]) {
      return fetchedFacets.reduce((acc: Record<string, any>, facet: any) => {
        acc[facet.name] = facet
        return acc
      }, {})
    }

    function getComponent(facet: any) {
      if (!facet) return null
      switch (facet.type) {
        case 'SmartFreeTextSearchHandler': {
          return ClassifiedQuickSearchSmartFreeTextHandler
        }
        case 'MakeModelSearchHandler': {
          return ClassifiedQuickSearchMakeModelHandler
        }
        case 'CategoryTreeSearchHandler': {
          return ClassifiedQuickSearchCategorySelectHandler
        }
        case 'FrontEndCategoryGridHandler': {
          return ClassifiedQuickSearchCategoryGridHandler
        }
        case 'FrontEndCategoryGridIconsHandler': {
          return ClassifiedQuickSearchCategoryGridIconsHandler
        }
        case 'FuelTypeSearchHandler':
        case 'RentalExtraServicesSearchHandler': {
          return ClassifiedQuickSearchSelectHandler
        }
        case 'Location2SearchHandler': {
          return ClassifiedQuickSearchLocationHandler
        }
        case 'OfferTypeCarsFrontEndSearchHandler': {
          return ClassifiedQuickSearchFrontEndOfferTypeCarsHandler
        }
        case 'RentalPickupLocationSearchHandler': {
          return ClassifiedQuickSearchPickupLocationHandler
        }
        case 'RentalPeriodSearchHandler': {
          return ClassifiedQuickSearchRentalPeriodHandler
        }
        case 'KeyValueSearchHandler': {
          return ClassifiedQuickSearchSelectHandler
        }
        case 'PostcodeDistanceSearchHandler': {
          return ClassifiedQuickSearchPostcodeHandler
        }
        case 'LocationSearchHandler': {
          return ClassifiedQuickSearchLocationAutocompleteHandler
        }
        case 'VehicleRegistrationSearchHandler':
        case 'RangeSearchHandler':
        case 'PriceSearchHandler':
        case 'EnginePowerSearchHandler':
        case 'LengthSearchHandler':
        case 'WeightSearchHandler':
        case 'RentalPassengersSearchHandler': {
          return ClassifiedQuickSearchSelectRangeHandler
        }
        default: {
          return null
        }
      }
    }

    function getModelValue(facet: any) {
      if (!facet) return null
      if (facet.name && facet.name !== 'grouped_facets') {
        // Only spread if the backend data exists and is different
        const backendData = facets.value[facet.name]
        if (backendData) {
          // Only update if the values are actually different
          if (
            JSON.stringify(backendData.values) !== JSON.stringify(facet.values)
          ) {
            return {
              ...facet,
              values: backendData.values
            }
          }
        }
      }
      return facet
    }

    function getCategoryIcon(categoryId: CategoryId) {
      return resolveCategory(categoriesIconsMappings, [categoryId])
    }

    function updateFacets(facet: any | any[]) {
      const currentQuery = { ...route.value.query }
      const facets = Array.isArray(facet) ? facet : [facet]

      facets.forEach(({ name, value }) => {
        if (!value || value === '' || value.length === 0) {
          delete currentQuery[name]
        } else {
          currentQuery[name] = value
        }
      })

      const hasQueryChanged =
        JSON.stringify(currentQuery) !== JSON.stringify(route.value.query)
      if (hasQueryChanged) {
        router.push({ query: currentQuery })
      }
    }

    function clearFacets() {
      router.push({ query: {} })
    }

    function getCategoriesFromRoute() {
      const firstLevelCategoryName = route.value.params.root as string
      const secondLevelCategoryName = route.value.params.category as string
      const thirdLevelCategoryName = route.value.params.subCategory as string

      const firstLevelCategory: QuickSearchCategory | null =
        quickSearchCategories[firstLevelCategoryName]
      const secondLevelCategory: QuickSearchCategory | null =
        firstLevelCategory?.children?.find(
          (child: QuickSearchCategory) => child.name === secondLevelCategoryName
        ) ?? null
      const thirdLevelCategory: QuickSearchCategory | null =
        secondLevelCategory?.children?.find(
          (child: QuickSearchCategory) => child.name === thirdLevelCategoryName
        ) ?? null

      return {
        firstLevelCategory,
        secondLevelCategory,
        thirdLevelCategory
      }
    }

    function getCategoryFacetsConfig(
      firstLevelCategory: QuickSearchCategory | null,
      secondLevelCategory: QuickSearchCategory | null,
      thirdLevelCategory: QuickSearchCategory | null
    ) {
      if (firstLevelCategory?.facets) {
        return firstLevelCategory.facets
      }
      if (thirdLevelCategory && secondLevelCategory?.children) {
        return thirdLevelCategory.facets
      }
      return secondLevelCategory?.facets
    }
    function openRecentSearches() {
      recentSearchesModalIsOpen.value = true
    }

    return {
      ciMap,
      ciChevronLeft,
      ciFilters,
      ciHistory,
      ciTrash,
      ciExternalLink,
      isPc,
      showCtaButton,
      selectedCategories,
      recentSearchesModalIsOpen,
      loading,
      count,
      resultsUrl,
      mapResultsUrl,
      categoryFacets,
      categoryChildren,
      categories,
      quickSearchHeading,
      hasSelectedFacets,
      showLoadingScreen,
      detailedSearchUrl,
      isPlotCategory,
      plotHeadingTranslationPath,
      isRentalsCategory,
      isCommercialsCategory,
      showMoreFiltersButton,
      showMiddleColumn,
      backButtonLocation,
      showDesktopBackButton,
      metadata,
      getComponent,
      getModelValue,
      getCategoryIcon,
      updateFacets,
      clearFacets,
      openRecentSearches,
      formatNumber
    }
  },
  head() {
    const title = this.isPlotCategory
      ? this.$t(this.plotHeadingTranslationPath, { link: 'Plot.gr' })
      : this.quickSearchHeading

    const description = this.isPlotCategory
      ? this.$t('real_estate_description')
      : this.metadata?.find((m: BackendMetaItem) => m.name === 'description')
          ?.content

    return {
      title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: description
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description
        }
      ]
    }
  },
  i18n: defineComponentTranslations({
    sale_real_estate_through: {
      en: 'Buy Real Estate through {link}',
      el: 'Πώληση ακινήτων μέσω {link}'
    },
    rent_real_estate_through: {
      en: 'Rent Real Estate through {link}',
      el: 'Ενοικίαση ακινήτων μέσω {link}'
    },
    booking_real_estate_through: {
      en: 'Booking Real Estate through {link}',
      el: 'Κράτηση ακινήτων μέσω {link}'
    },
    wanted_real_estate_through: {
      en: 'Wanted Real Estate through {link}',
      el: 'Ζήτηση ακινήτων μέσω {link}'
    },
    real_estate_description: {
      en:
        'Looking for real estate classifieds? Search for houses, plots & commercial spaces. Find properties from private sellers, builders & real estate agents in Greece!',
      el:
        'Ψάχνεις αγγελίες σπιτιών, οικοπέδων & επαγγελματικών χώρων; Αναζήτησε ακίνητα από ιδιώτες, κατασκευαστές & μεσίτες στην Ελλάδα!'
    },
    cars_search: {
      en: 'Cars Search',
      el: 'Αναζήτηση Αυτοκινήτων'
    },
    bikes_search: {
      en: 'Bikes Search',
      el: 'Αναζήτηση Μοτοσυκλετών'
    },
    boats_search: {
      en: 'Boats Search',
      el: 'Αναζήτηση Σκαφών'
    },
    commercials_search: {
      en: 'Commercial Search',
      el: 'Αναζήτηση Επαγγελματικών'
    },
    commercials_vans_search: {
      en: 'Search for vans',
      el: 'Αναζήτηση φορτηγών έως 7,5τ'
    },
    commercials_trucks_search: {
      en: 'Search for trucks',
      el: 'Αναζήτηση φορτηγών άνω των 7,5τ'
    },
    commercials_tractors_search: {
      en: 'Search for tractors',
      el: 'Αναζήτηση γεωργικών'
    },
    commercials_builders_search: {
      en: 'Search for builders',
      el: 'Αναζήτηση μηχανημάτων'
    },
    commercials_semitrucks_search: {
      en: 'Search for semitrucks',
      el: 'Αναζήτηση τρακτόρων'
    },
    commercials_semitrailers_search: {
      en: 'Search for semitrailers',
      el: 'Αναζήτηση επικαθήμενων'
    },
    commercials_buses_search: {
      en: 'Search for buses',
      el: 'Αναζήτηση λεωφορείων'
    },
    commercials_forklifts_search: {
      en: 'Search for forklifts',
      el: 'Αναζήτηση κλάρκ'
    },
    commercials_trailers_search: {
      en: 'Search for trailers',
      el: 'Αναζήτηση ρυμουλκών/τρέιλερ'
    },
    commercials_taxis_search: {
      en: 'Search for taxis',
      el: 'Αναζήτηση ταξί'
    },
    campers_search: {
      en: 'Campers Search',
      el: 'Αναζήτηση Τροχόσπιτων'
    },
    bicycles_search: {
      en: 'Bicycles Search',
      el: 'Αναζήτηση Ποδηλάτων'
    },
    hobby_search: {
      en: 'Hobby Search',
      el: 'Αναζήτηση Χόμπι'
    },
    cars_rentals: {
      en: 'Cars Rentals',
      el: 'Ενοικιάσεις Αυτοκινήτων'
    },
    bikes_rentals: {
      en: 'Bikes Rentals',
      el: 'Ενοικιάσεις Μοτοσυκλετών'
    },
    boats_rentals: {
      en: 'Boats Rentals',
      el: 'Ενοικιάσεις Σκαφών'
    },
    commercials_rentals: {
      en: 'Commercials Rentals',
      el: 'Ενοικιάσεις Επαγγελματικών'
    },
    campers_rentals: {
      en: 'Campers Rentals',
      el: 'Ενοικιάσεις Τροχόσπιτων'
    },
    bicycles_rentals: {
      en: 'Bicycles Rentals',
      el: 'Ενοικιάσεις Ποδηλάτων'
    },
    misc_rentals: {
      en: 'Miscellaneous Rentals',
      el: 'Ενοικιάσεις Διάφορων'
    }
  })
})
